import React from "react";
import LineCreator from "./LineCreator";

const LineGenerator = ({ index, roundsList, matches }) => {

  return roundsList[0].rounds == 128 ? (
    <>
      {matches.length == 64 && (
        <LineCreator
          index={index}
          divider2Style="25px"
          divider2Height="45px"
          divider3Style="78%"
        />
      )}

      {matches.length == 32 && (
        <LineCreator
          index={index}
          divider2Height="88px"
          divider2Style="67px"
          divider3Style="132%"
        />
      )}

      {matches.length == 16 && (
        <LineCreator
          index={index}
          divider2Height="177px"
          divider2Style="157px"
          divider3Style="245%"
        />
      )}

      {matches.length == 8 && (
        <LineCreator
          index={index}
          divider2Height="705px"
          divider2Style="685px"
          divider3Style="470%"
        />
      )}

      {matches.length == 4 && (
        <LineCreator
          index={index}
          divider2Height="705px"
          divider2Style="685px"
          divider3Style="900%"
        />
      )}

      {matches.length == 2 && (
        <LineCreator
          index={index}
          divider2Height="1410px"
          divider2Style="1390px"
          // divider2Padding={0.5}
          divider3Style="1787%"
        />
      )}

      {matches.length == 1 && (
        <LineCreator
          index={index}
          divider2Height="2820px"
          divider2Style="2800px"
          divider3Style="3540%"
        />
      )}
    </>
  ) : roundsList[0].rounds == 64 ? (
    <>
      {matches.length == 32 && (
        <LineCreator
          index={index}
          divider2Style="25px"
          divider2Height="45px"
          divider3Style="78%"
        />
      )}

      {matches.length == 16 && (
        <LineCreator
          index={index}
          divider2Height="88px"
          divider2Style="67px"
          divider3Style="132%"
        />
      )}

      {matches.length == 8 && (
        <LineCreator
          index={index}
          divider2Height="177px"
          divider2Style="157px"
          divider3Style="240%"
        />
      )}

      {matches.length == 4 && (
        <LineCreator
          index={index}
          divider2Height="352px"
          divider2Style="332px"
          divider3Style="460%"
        />
      )}

      {matches.length == 2 && (
        <LineCreator
          index={index}
          divider2Height="705px"
          divider2Style="685px"
          divider3Style="900%"
        />
      )}

      {matches.length == 1 && (
        <LineCreator
          index={index}
          divider2Height="1410px"
          divider2Style="1390px"
          divider3Style="1780%"
        />
      )}
    </>
  ) : roundsList[0].rounds == 32 ? (
    <>
      {matches.length == 16 && (
        <LineCreator
          index={index}
          divider2Style="25px"
          divider2Height="45px"
          divider3Style="78%"
        />
      )}

      {matches.length == 8 && (
        <LineCreator
          index={index}
          divider2Height="88px"
          divider2Style="67px"
          divider3Style="132%"
        />
      )}

      {matches.length == 4 && (
        <LineCreator
          index={index}
          divider2Height="177px"
          divider2Style="156px"
          divider3Style="240%"
          // divider2Padding={0.15}
        />
      )}

      {matches.length == 2 && (
        <LineCreator
          index={index}
          divider2Height="352px"
          divider2Style="332px"
          // divider2Padding={0.15}
          divider3Style="465%"
        />
      )}

      {matches.length == 1 && (
        <LineCreator
          index={index}
          divider2Height="705px"
          divider2Style="685px"
          divider3Style="900%"
        />
      )}
    </>
  ) : roundsList[0].rounds == 16 ? (
    <>
      {matches.length == 8 && (
        <LineCreator
          index={index}
          divider2Style="25px"
          divider2Height="45px"
          divider3Style="78%"
        />
      )}

      {matches.length == 4 && (
        <LineCreator
          index={index}
          divider2Height="88px"
          divider2Style="67px"
          divider3Style="132%"
        />
      )}

      {matches.length == 2 && (
        <LineCreator
          index={index}
          divider2Height="177px"
          divider2Style="157px"
          // divider2Padding={0.15}
          divider3Style="245%"
        />
      )}

      {matches.length == 1 && (
        <LineCreator
          index={index}
          divider2Height="353px"
          divider2Style="333px"
          divider3Style="460%"
        />
      )}
    </>
  ) : roundsList[0].rounds == 8 ? (
    <>
      {matches.length == 4 && (
        <LineCreator
          index={index}
          divider2Style="25px"
          divider2Height="45px"
          divider3Style="78%"
        />
      )}

      {matches.length == 2 && (
        <LineCreator
          index={index}
          divider2Height="88px"
          divider2Style="67px"
          divider3Style="132%"
        />
      )}

      {matches.length == 1 && (
        <LineCreator
          index={index}
          divider2Height="176px"
          divider2Style="155px"
          divider3Style="242%"
        />
      )}
    </>
  ) : roundsList[0].rounds == 4 ? (
    <>
      {matches.length == 2 && (
        <LineCreator
          index={index}
          divider2Style="25px"
          divider2Height="45px"
          divider3Style="78%"
        />
      )}

      {matches.length < 2 && (
        <LineCreator
          index={index}
          divider2Height="88px"
          divider2Style="67px"
          divider3Style="132%"
        />
      )}
    </>
  ) : null;
};

export default LineGenerator;
